export const csvInput = [
  'text/csv' || '.csv',
  // '.xls',
  // '.xslx',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];
